module.exports = __webpack_public_path__ + "static/user-avatar-fb73e8a1e098f0b28caa3b682e78e7a6.png";